import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ModalArtworkTile from 'components/ArtworkTile/components/ModalArtworkTile';
import BlurredModal from 'components/Modal/BlurredModal';
import Loader from 'components/Modal/Loader';
import { MusicButton } from 'components/MusicButton';
import { PODCAST_HIDE_MODAL, SELECT_HIDE_PODCAST } from 'constants/metrics';
import { PageContext } from 'contexts';
import useGetPodcastDetails from 'hooks/getPodcastDetails';
import { usePageView } from 'hooks/pageView';
import { modalPodcastIdSelector } from 'store/selectors/modal';
import { hidePodcast } from 'store/slices/podcasts';
import { closeModal } from 'store/slices/modal';
import './styles.scss';

const Title = (
  <h4>
    <FormattedMessage id="hideModal-title" />
  </h4>
);

const HideModal = () => {
  const modalPodcastId = useSelector(modalPodcastIdSelector);
  const { podcastDetailsLoading } = useGetPodcastDetails(modalPodcastId);
  usePageView(PODCAST_HIDE_MODAL);
  const dispatch = useDispatch();

  const onHidePodcast = () => {
    dispatch(hidePodcast({ id: modalPodcastId }));
    dispatch(closeModal());
  };

  return (
    <PageContext.Provider value={PODCAST_HIDE_MODAL}>
      {podcastDetailsLoading ? (
        <Loader />
      ) : (
        <BlurredModal title={Title}>
          <div className="HideModal__content-container">
            <p className="bodyPrimary secondary-text">
              <FormattedMessage
                id="hideModal-description"
                defaultMessage="Hiding your show makes it temporarily unavailable to listeners on Amazon Music and Audible. It can take up to 1 hour to hide."
              />
            </p>
            <div className="HideModal__artwork">
              <ModalArtworkTile />
            </div>
            <MusicButton
              variant="solid"
              className="MusicButton__wide"
              data-id={`${SELECT_HIDE_PODCAST}-${PODCAST_HIDE_MODAL}`}
              onMusicActivate={onHidePodcast}
            >
              <FormattedMessage id="hideModal-button" />
            </MusicButton>
          </div>
        </BlurredModal>
      )}
    </PageContext.Provider>
  );
};

export default HideModal;
